import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import checkIcon from "../../assets/sol-check.svg";
import HeaderAny from "../../components/header";
import MobileNav from "../../components/header-mobile";
import Footer from "../../components/footer";
import { getSolution } from "./solutions-data";
import "./solutions.css";

const GET_STARTED_URL = "https://web.conra.net";

const SolutionPage = () => {
    const { slug } = useParams();
    const solution = getSolution(slug);

    if (!solution) return <Navigate to="/404" replace />;

    const { overtitle, title, titleHighlight, subtitle, heroImage, heroImageMaxWidth, heroDecor, heroBadge, heroLayout, benefitsIntro, benefits, detail } = solution;
    const isSplitHero = heroLayout === "split" && heroImage;

    return (
        <div>
            <div className="web-only">
                <HeaderAny />
            </div>
            <div className="mobile-only">
                <MobileNav />
            </div>

            {/* ── Hero ── */}
            <section className={`sol-hero ${isSplitHero ? "is-split" : ""}`}>
                {heroDecor && (
                    <img src={heroDecor} alt="" className="sol-hero-curl" aria-hidden="true" />
                )}
                {heroBadge && (
                    <img src={heroBadge} alt="" className="sol-hero-badge-img" aria-hidden="true" />
                )}
                <div className="sol-hero-main">
                    <p className="sol-overtitle">{overtitle}</p>
                    <h1 className="sol-title">
                        {title} <span>{titleHighlight}</span>
                    </h1>
                    <p className="sol-subtitle">{subtitle}</p>
                    <div className="sol-hero-actions">
                        <button
                            className="filled-button"
                            onClick={() => window.open(GET_STARTED_URL, "_blank")}
                        >
                            Get Started <FaArrowRight style={{ marginLeft: 6 }} />
                        </button>
                        {/* <button
                            className="sol-outlined-button"
                            onClick={() => window.open(GET_STARTED_URL, "_blank")}
                        >
                            See How it Works
                        </button> */}
                    </div>
                </div>

                {heroImage && (
                    <div
                        className="sol-hero-visual"
                        style={heroImageMaxWidth ? { maxWidth: heroImageMaxWidth } : undefined}
                    >
                        <img src={heroImage} alt={`${overtitle} preview`} className="sol-hero-img" />
                    </div>
                )}
            </section>

            {/* ── Key Benefits ── */}
            <section className="sol-benefits">
                <h2 className="h1-48-600">Key <span>Benefits</span></h2>
                <p className="sol-benefits-intro">{benefitsIntro}</p>
                <div className="sol-benefits-grid">
                    {benefits.map((b, i) => (
                        <div key={b.title} className="sol-benefit-card">
                            <div className={`sol-benefit-icon ${(b.tile || (i % 2 === 0 ? "blue" : "gold")) === "blue" ? "is-blue" : "is-gold"}`}>
                                {b.iconSrc
                                    ? <img src={b.iconSrc} alt="" className="sol-benefit-icon-img" />
                                    : <b.icon />}
                            </div>
                            <div className="sol-benefit-body">
                                <h4 className="sol-benefit-title">{b.title}</h4>
                                <p className="sol-benefit-desc">{b.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── Detail ── */}
            <section className={`sol-detail ${detail.cards ? "has-cards" : ""}`}>
                {detail.cards ? (
                    <div className="sol-stage-inner">
                        <h2 className="sol-detail-title sol-stage-heading">
                            {detail.title} <span>{detail.titleHighlight}</span>
                        </h2>
                        <p className="sol-detail-paragraph sol-stage-intro">{detail.paragraph}</p>
                        <div className="sol-stage-grid">
                            {detail.cards.map((card) => (
                                <div
                                    key={card.title}
                                    className={`sol-stage-card tint-${card.tint} ${card.wide ? "is-wide" : ""}`}
                                >
                                    <div className="sol-stage-text">
                                        <h4 className="sol-stage-title">{card.title}</h4>
                                        <p className="sol-stage-desc">{card.desc}</p>
                                    </div>
                                    <div className="sol-stage-visual">
                                        <img src={card.image} alt={card.title} className="sol-stage-img" />
                                        {card.imageLabel && (
                                            <span className="sol-stage-img-label">{card.imageLabel}</span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                <div className={`sol-detail-inner ${detail.image ? "has-image" : ""} ${detail.imagePosition === "left" ? "image-left" : ""}`}>
                    <div className="sol-detail-text">
                        {detail.overtitle && <p className="sol-detail-overtitle">{detail.overtitle}</p>}
                        <h2 className="sol-detail-title">
                            {detail.title} <span>{detail.titleHighlight}</span>
                        </h2>
                        <p className="sol-detail-paragraph">{detail.paragraph}</p>
                        <ul className="sol-checklist">
                            {detail.checklist.map((item) => (
                                <li key={item.title} className="sol-checklist-item">
                                    {item.iconSrc
                                        ? <img src={item.iconSrc} alt="" className="sol-check-img" />
                                        : <img src={checkIcon} alt="" className="sol-check-icon" />}
                                    <div>
                                        <p className="sol-check-title">{item.title}</p>
                                        {item.desc && <p className="sol-check-desc">{item.desc}</p>}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {detail.image && (
                        <div className="sol-detail-visual">
                            <img src={detail.image} alt="" className="sol-detail-img" />
                        </div>
                    )}
                </div>
                )}
            </section>

            {/* ── CTA ── */}
            <section className="sol-cta">
                <h2 className="h1-48-600">Ready to <span>Publish</span> Your Projects ?</h2>
                <p className="sol-cta-sub">
                    See how ConRa can help your construction team publish verified project updates and evidence in one secure platform.
                </p>
                <button
                    className="filled-button"
                    onClick={() => window.open(GET_STARTED_URL, "_blank")}
                >
                    Get Started <FaArrowRight style={{ marginLeft: 6 }} />
                </button>
            </section>

            <Footer />
        </div>
    );
};

export default SolutionPage;
